import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_HANDLE_IDS } from '../../index';
import { Body5 } from '@ui';
import styled from 'styled-components';
import { colorPalette } from '@theme';

const YES_DEFAULT_HANDLE_STYLE = {
  top: '17px',
  right: '4px',
};
const NO_DEFAULT_HANDLE_STYLE = {
  top: '47px',
  right: '4px',
};

const Wrapper = styled.div`
  position: relative;
`;
const YesLabel = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  pointer-events: auto;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
`;
const NoLabel = styled.div`
  position: absolute;
  top: 38px;
  right: 12px;
  pointer-events: auto;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
`;

export const PlanStepsYesConditionalSourceHandle = React.memo(
  ({ data, isConnectable, nodeId, onRemoveConnectedEdges }) => {
    const id = NODE_HANDLE_IDS.planStepYes;

    const handleDoubleClick = () => {
      if (!isConnectable) return;
      if (onRemoveConnectedEdges) {
        onRemoveConnectedEdges(nodeId, id, 'source');
      }
    };

    return (
      <Wrapper>
        <YesLabel onDoubleClick={handleDoubleClick} $disabled={!isConnectable}>
          <Body5 bold uppercase>
            Yes
          </Body5>
        </YesLabel>
        <Handle
          type="source"
          id={id}
          position={Position.Right}
          style={{
            background: colorPalette.secondary.brightGreen,
            cursor: isConnectable ? undefined : 'not-allowed',
            ...YES_DEFAULT_HANDLE_STYLE,
          }}
          onConnect={(params) => console.log('handle onConnect', params)}
          isConnectable={isConnectable}
          isConnectableStart={isConnectable}
        />
      </Wrapper>
    );
  }
);

export const PlanStepsNoConditionalSourceHandle = React.memo(
  ({ data, isConnectable, nodeId, onRemoveConnectedEdges }) => {
    const id = NODE_HANDLE_IDS.planStepNo;

    const handleDoubleClick = () => {
      if (!isConnectable) return;
      if (onRemoveConnectedEdges) {
        onRemoveConnectedEdges(nodeId, id, 'source');
      }
    };

    return (
      <Wrapper>
        <NoLabel onDoubleClick={handleDoubleClick} $disabled={!isConnectable}>
          <Body5 bold uppercase>
            No
          </Body5>
        </NoLabel>
        <Handle
          type="source"
          id={id}
          position={Position.Right}
          style={{
            background: colorPalette.secondary.brightGreen,
            cursor: isConnectable ? undefined : 'not-allowed',
            ...NO_DEFAULT_HANDLE_STYLE,
          }}
          onConnect={(params) => console.log('handle onConnect', params)}
          isConnectable={isConnectable}
          isConnectableStart={isConnectable}
        />
      </Wrapper>
    );
  }
);
